import React from 'react'
import Reflux from 'reflux'
import Store from '../../../store/store'
import logo from '../../../images/logo.png'
import {Link} from 'react-router-dom'
import actions from '../../../actions/actions'
import api from '../../../source/api'
import user from '../../../helpers/user'
import userHelper from '../../../helpers/user'

export default class Header extends Reflux.Component {

    constructor(props) {
        super(props)
        this.store = Store
    }

    logout = () => {
        actions.logout()
        localStorage.removeItem('user')
        window.location.reload(true)
    }

    getIdFormUrl = () => {
        let hash = window.location.hash
        let id = ''
        if (hash != '#/' && /\d/.test(hash)) {
            id = hash.replace(/^\D+/g, '')
        }
        return id
    }

    componentDidMount = () => {
        if (!user.isGuest()) {
            api.get({url: 'user/getbalance'}, true).then((response) => {
                if (response.status === 200) {
                    actions.userBalanceSet(response.data.balance)
                }
            })
        }
    }


    render() {
        let id = this.getIdFormUrl()
        let isGuest = user.isGuest()
        let nolink = this.props.nolink
        return (
            <section id='header'>
                <nav className='navbar navbar-expand-lg'>
                    <div className='container'>
                        <Link className='navbar-brand' to='/'>
                            <img className='header-logo img-fluid' src={logo} title='logo' alt='logo'/>
                        </Link>
                        <button className='navbar-toggler' type='button' data-toggle='collapse' data-target='#navbarSupportedContent' aria-controls='navbarSupportedContent' aria-expanded='false' aria-label='Toggle navigation'>
                            <span className='navbar-toggler-icon'></span>
                        </button>

                        <div className='collapse navbar-collapse' id='navbarSupportedContent'>
                            <ul className={nolink ? 'd-none' : 'navbar-nav ml-auto'}>
                                <li className={!isGuest && window.location.hash !== '#/' && id && userHelper.hasModule('customer') ? 'nav-item active' : 'd-none'}>
                                    <Link className='bold nav-link' to={'/start/customer/' + id}>
                                        Vevő <span className='sr-only'>(current)</span>
                                    </Link>
                                </li>
                                <li className={!isGuest && window.location.hash !== '#/' && id && userHelper.hasModule('bank') ? 'nav-item' : 'd-none'}>
                                    <Link className='bold nav-link' to={'/start/bank/' + id}>
                                        Bank <span className='sr-only'>(current)</span>
                                    </Link>
                                </li>
                                <li className={!isGuest && window.location.hash !== '#/' && id && userHelper.hasModule('supplier') ? 'nav-item' : 'd-none'}>
                                    <Link className='bold nav-link' to={'/start/supplier/' + id}>
                                        Szállító <span className='sr-only'>(current)</span>
                                    </Link>
                                </li>
                                <li className={!isGuest && window.location.hash !== '#/' && id && userHelper.hasModule('cashregister') ? 'nav-item' : 'd-none'}>
                                    <Link className='bold nav-link' to={'/start/cash-register/' + id}>
                                        Pénztárgép <span className='sr-only'>(current)</span>
                                    </Link>
                                </li>
                                {isGuest ? <li className='nav-item'>
                                    <Link className='nav-link' to='/login'>
                                        Bejelentkezés
                                    </Link>
                                </li> : ''}
                                {isGuest ? <li className='nav-item'>
                                    <a target='_blank' className='nav-link' href='https://beeker.hu/'>
                                        Mi is az a Beeker?
                                    </a>
                                </li> : ''}
                                {!isGuest && userHelper.showBalance()
                                    ? <li className='nav-item balance-info'>
                                        Rendelkezésre álló egyenleg: {this.state.balance} Ft
                                    </li>
                                    : null
                                }
                                {!isGuest && userHelper.showBalance()
                                    ? <li className='nav-item'>
                                        <Link className='nav-link' to='/payment-start'>Egyenleg feltöltése</Link>
                                    </li>
                                    : null
                                }
                                {!isGuest && userHelper.isTestMode()
                                    ? <li className='nav-item balance-info'>
                                        Teszt üzemmód lejárata: {userHelper.testModeExpiration()}
                                    </li>
                                    : null
                                }
                                {!isGuest ?
                                    <li className='nav-item'>
                                        <Link className='nav-link' to={'/user-profile'}>
                                            Profil
                                        </Link>
                                    </li>
                                    : ''}
                                {!isGuest ?
                                    <li className='nav-item'>
                                        <a className='nav-link' onClick={() => this.logout()}>
                                            Kijelentkezés
                                        </a>
                                    </li> : ''
                                }
                            </ul>
                        </div>
                    </div>
                </nav>
            </section>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/common/header/header.js